<template>
  <b-badge
    v-if="missing > 0"
    variant="light-danger"
    class="ml-50"
    :title="`${missing} of ${total} attachment(s) missing from storage`"
  >
    {{ missing }}/{{ total }} missing
  </b-badge>
</template>

<script>
import { BBadge } from 'bootstrap-vue'

export default {
  components: { BBadge },
  props: {
    item: { type: Object, required: true },
  },
  computed: {
    missing() { return Number(this.item.missing_files) || 0 },
    total() { return Number(this.item.total_files) || 0 },
  },
}
</script>
